export const isOptgroupSymbol = Symbol('isOptgroup')
export const isOptSelectAllSymbol = Symbol('isOptSelectAll')
export const draggableOptionIdSymbol = Symbol()
